import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { KPIResponse } from 'api/ControllingApi';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

export async function getHistorical(axios: AxiosInstance): Promise<KPIResponse> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/controlling/historical`);
  return data;
}

export default function useControllingHistoricalQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getHistorical(axios),
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['ControllingKpis'] as const satisfies QueryKey;
}
useControllingHistoricalQuery.getKey = getKey;
